module.exports = __webpack_public_path__ + "img/reduced-wait-time.ded16ae1.svg";